export const LOGOUT = 'LOGOUT';

/**
 * KNOWLEDGE
 */
export const SET_KNOWLEDGES = 'SET_KNOWLEDGES';
export const SET_FOCUS_KNOWLEDGE = 'SET_FOCUS_KNOWLEDGE';
export const SET_FOCUS_KNOWLEDGE_ROOTS = 'SET_FOCUS_KNOWLEDGE_ROOTS';
export const INIT_KNOWLEDGE = 'INIT_KNOWLEDGE';
export const UPDATE_KNOWLEDGE = 'UPDATE_KNOWLEDGE';

/**
 * NAVIGATION
 */
export const UPDATE_PATH = 'UPDATE_PATH';
export const UPDATE_DIAG_PATH = 'UPDATE_DIAG_PATH';
export const SET_FOCUS_NAV_ITEM = 'SET_FOCUS_NAV_ITEM';
export const SET_FOCUS_DIAG_ITEM = 'SET_FOCUS_DIAG_ITEM';
export const UPDATE_PREVIOUS_ITEMS = 'UPDATE_PREVIOUS_ITEMS';
export const SET_NAVIGATION_LANGUAGE = 'SET_NAVIGATION_LANGUAGE';

/**
 * SEARCH
 */
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const UPDATE_SEARCH_SIZE = 'UPDATE_SEARCH_SIZE';
export const UPDATE_SEARCH_FILTERS = 'UPDATE_SEARCH_FILTERS';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';
export const UPDATE_RECENT_SEARCHES = 'UPDATE_RECENT_SEARCHES';
export const UPDATE_FREQUENT_SEARCHES = 'UPDATE_FREQUENT_SEARCHES';
export const UPDATE_SEARCH_FOCUS_LEVEL = 'UPDATE_SEARCH_FOCUS_LEVEL';

/**
 * LOADING
 */
export const SET_LOADING = 'SET_LOADING';

/**
 * USER
 */
export const UPDATE_FAVORITES = 'UPDATE_FAVORITES';
export const SET_USER_INFOS = 'SET_USER_INFOS';
